// import {config} from "@/config";
import request from "@/utils/request";

// 创建保存订单
export function orderCreate(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/add",
    data: data,
  });
}
// 提交订单
export function orderSubmit(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/submit",
    data: data,
  });
}

// 查询订单列表
export function orderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/list",
    data: data,
  });
}

// 查询订单详情
export function orderGet(id) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/" + id,
    method: "GET",
  });
}

// 订单审核
export function orderReview(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/review",
    data: data,
  });
}

// 订单协议
export function agreement(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/agreement",
    data: data,
  });
}

// 财务开发票（提交）
export function orderApply(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/invoices/apply",
    data: data,
  });
}
// 财务开发票（保存）
export function orderSave(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/invoices/save",
    data: data,
  });
}

// 订单线下支付的财务审核
export function auditPayStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/auditPayStatus",
    data: data,
  });
}

// 线下财务审核历史记录
export function orderPayAudit(id) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/orderPayAudit/" + id,
    method: "GET",
  });
}

// 对账管理支付对账订单列表
export function accountPayList(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/accountPayList",
    data: data,
  });
}

// 对账管理开票对账订单列表
export function accountInvoiceList(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/accountInvoiceList",
    data: data,
  });
}

// 存储专属客服信息
export function customerServicePerson(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/customerServicePerson/save",
    data: data,
  });
}

// 获取专属客服信息
export function getCustomerServicePerson() {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + "/orders/customerServicePerson/detail",
  });
}

// ----------------------------------------------------------------
// 应用列表

export function applicationList(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/company/appList",
    data: data,
  });
}
// 企业查询
export function detailCompany(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/company/detailCompany",
    data: data,
  });
}
// 应用详情查询
export function detailsApp(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + "/company/detailsApp",
    data: data,
  });
}
export function getUserInfoMes(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + `/orders/getCurrentUserOE/${data}`,
    method: "GET",
  });
}
export function getCmpInfoForUser(data) {
  return request({
    url: process.env.VUE_APP_BASE_URL_API + `/orders/getCmpInfoForUser`,
    data,
  });
}
export function getQueryRights(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + `/company/queryRights`,
    data,
  });
}
export function getDetailComByTen(data) {
  return request({
    url: process.env.VUE_APP_BASE_TVRJET + `/company/detailComByTen`,
    data,
  });
}
